var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"operative-table-section-title"},[_c('th',{class:{ 'text-left': _vm.align === 'left', 'text-center': _vm.align === 'center', 'text-right': _vm.align === 'right' },attrs:{"colspan":_vm.numColumns}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }